// extracted by mini-css-extract-plugin
export default {"container":"layout_container__R4yWw","headerz":"layout_headerz__VELD2"};